export default __webpack_public_path__ + "static/media/1862.05c23144.png";